module.exports = __webpack_public_path__ + "assets/img/textSummarization.491dbf73.png";